import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/Header';
import Footer from '../components/Footer';

import './bootstrap.css';
import './theme.css';
import './fonts/font-awesome/css/font-awesome.css';

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={'Jamocha Media'}
      meta={[
        {
          name: "description",
          content: "Jamocha Media - We Create Influencers",
        },
        {
          name: "keywords",
          content:
            "LinkedIn, freelance, copywriting, influencer",
        },
      ]}
    >
      <link
        href="https://fonts.googleapis.com/css?family=Nunito:400,600,700,800|Roboto:400,500,700"
        rel="stylesheet"
      />
    </Helmet>
    <Header />
    {children()}
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.func,
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js